import React from 'react';
import Context from './context';
import AppTypography from '../../core/Typography/AppTypography';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import FuruPoImage from '../../../images/features/jtb/furu-po.png';
import { FURUPO } from './variables';

const About = () => {
  const { classes } = React.useContext(Context);

  return (
    <div className={classes.titleBox}>
      <AppTypography
        className="title"
        color="props.palette.secondary.main"
        size={24}
        weight="bold"
        align="center"
      >
        JTB ふるぽとは
      </AppTypography>
      <Box display="flex" flexDirection={{ xs: 'column-reverse', sm: 'row' }}>
        <div>
          <AppTypography color="palette.text.primary" mb={2.5}>
            「旅の数だけふるさとが増えていく。ふるさと納税で旅に出よう」をコンセプトに、全国にある⾃治体の魅⼒をふるさと納税サイト「ふるぽ」を通じて発信しています。
            ふるさと納税などを通じて地域を応援し、地域の担い手となる人を増やすために、今回都市部からの「関係人口」を創出することを目指すおてつたびとコラボが実現しました。
            より多くの⽅が「旅」を通じて、自分の新しい故郷を増やすことを応援しています。
          </AppTypography>
          <AppTypography color="palette.text.primary">
            <span>JTBふるぽ 公式サイト：</span>
            <Link
              href={FURUPO}
              target="_blank"
              className="text-break-all"
              underline="always"
            >
              {FURUPO}
            </Link>
          </AppTypography>
        </div>
        <Box
          textAlign="center"
          ml={{ xs: 0, sm: 5 }}
          mb={{ xs: 6, sm: 0 }}
          width="100%"
        >
          <Box
            component="img"
            src={FuruPoImage}
            width="100%"
            height="auto"
            maxWidth={{ xs: 150, sm: 180 }}
          />
        </Box>
      </Box>
    </div>
  );
};

export default About;
